export const CONSTANTS = {
    I9_FORMS: {
        EMPLOYEE_DETAILS: {

        }
    },
    ADVANCE_PAYROLL: "eAdvance",
    EXPENSES_PAYROLL: "eExpenses",
    EXPENSES_EXPENSE: "eExpense",
    REFUNDS_PAYROLL: "eRefunds",
    ACTION_SUBSTRING: "populateFieldBySubstrig",
    ACTION_SUBLOOKUP: "lookup",
    ACTION_ASYNC: "async",

    CLIENT_DETAILS: "bDetails",
    FILE_UPLOAD: 'fileUpload',
    IMMIGRATION_DETAILS: "iDetails",
    EMPLOYEE_DETAILS: 'bDetails',
    ADDRESS_DETAILS: 'aDetails',
    PROJECT_DETAILS: 'pDetails',
    CLIENT_DETAILS_ASYNC: "clientDetail",
    VENDOR_DETAILS_ASYNC: "vendorDetail",
    CLIENTSPOCCLIENT_ASYNC: "clientSpocClientDetail",
    JS_PA_ASYNC:"jsPanelDetails"
};

export const FORMNAMES =
{
    TAB_1: "Tab1",
    TAB_2: "Tab2",
    TAB_3: "Tab3",
    TAB_4: "Tab4",
    TAB_5: "Tab5",
    TAB_6: "Tab6",
    TAB_7: "Tab7",
    TAB_8: "Tab8",
    TAB_9: "Tab9",
    TAB_10: "Tab10",
    TAB_11: "Tab11",
    TAB_12: "Tab12",
    TAB_13: "Tab13"
};

export const ANOUNCEMENTFORMNAME =
{
    ANOUNCEMENT_DETAILS_TAB_1: "AnoouncementTab1"
};